/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import Typography from '@material-ui/core/Typography';
import {
    makeStyles,
} from '@material-ui/core';
import {
    object,
} from 'prop-types';
import replaceSpecialChar from '../../../../../helpers/replaceSpecialChar';
import ResponsiveWrapper from '../../../UniversalTemplate/SubComponents/ResponsiveWrapper';

const useStyles = makeStyles((theme) => ({
    largePromo: {
        display: 'flex',
        flexDirection: 'row',
        margin: theme.palette?.pdp?.largePromo?.desktopMargin || '0px 0px 32px 0px',
        [theme.breakpoints.down('600')]: {
            flexDirection: 'column',
            margin: theme.palette?.pdp?.largePromo?.mobileMargin || '0px 0px 16px 0px',
        },
    },
    imageProp: {
        height: 'auto',
        width: '50%',
        [theme.breakpoints.down('600')]: {
            width: '100%',
        },
    },
    promoBlock: ({ promoStyles }) => ({
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.palette?.pdp?.largePromo?.gap?.promo || '24px',
        padding: theme.palette?.pdp?.largePromo?.padding?.desktop  || ' 64px 62px 64px 62px',
        backgroundColor: promoStyles?.color || '#CBDDEB',
        alignItems: 'center',
        [theme.breakpoints.down('1025')]: {
            padding: theme.palette?.pdp?.largePromo?.padding?.tablet  || '40px',
        },
        [theme.breakpoints.down('900')]: {
            padding: theme.palette?.pdp?.largePromo?.padding?.mobile  || '24px 16px 24px 16px',
        },
        [theme.breakpoints.down('600')]: {
            width: '100%',
        },
    }),
    singleSubHeadingBlock: {
        gap: theme.palette?.pdp?.largePromo?.gap?.subHeading || '16px',
        display: 'flex',
        flexDirection: 'column',
    },
    subHeadingNestedBlock: {
        gap: theme.palette?.pdp?.largePromo?.gap?.subHeadingNested || '8px',
        display: 'flex',
        flexDirection: 'column',
    },
    heading: {
        fontFamily: theme.typography.secondaryFontFamily || theme.typography.fontFamily,
        fontSize: theme.palette?.pdp?.largePromo?.heading?.fontSize ||  '24px',
        fontWeight: theme.palette?.pdp?.largePromo?.heading?.fontWeight || 500,
        letterSpacing: theme.palette?.pdp?.largePromo?.heading?.letterSpacing || '0.01em',
    },
    sub_heading: {
        letterSpacing: theme.palette?.pdp?.largePromo?.subHeading?.letterSpacing || '0.02em',
        lineHeight: theme.palette?.pdp?.largePromo?.subHeading?.lineHeight ||  '24px',
    },
    secondHeading: {
        fontWeight: theme.palette?.pdp?.largePromo?.heading?.secondFontWeight || 600,
        letterSpacing: theme.palette?.pdp?.largePromo?.heading?.secondLetterSpacing || '0.14em',
        lineHeight: theme.palette?.pdp?.largePromo?.subHeading?.lineHeight || '24px',
        textTransform: theme.palette?.pdp?.largePromo?.subHeading?.textTransform ||  'uppercase',
    },
    nestedSubHeading: {
        fontWeight: theme.palette?.pdp?.largePromo?.subHeading?.fontWeight || 500,
        '& span': {
            fontWeight: theme.palette?.pdp?.largePromo?.subHeading?.fontWeightSpan ||  400,
        },
    },
}));

const PDPLargePromoBlock = ({
    promoData, promoStyles,
}) => {
    const classes = useStyles({ promoStyles });
    if (!promoData) {
        return null;
    }
    const device = (matches) => Object.keys(matches).find((key) => matches[key]); // returns device type string
    const backgrounds = {
        desktop: promoData?.background_image?.desktop?.url,
        tablet: promoData?.background_image?.tablet?.url || promoData?.background_image?.desktop?.url,
        mobile: promoData?.background_image?.mobile?.url || promoData?.background_image?.tablet?.url || promoData?.background_image?.desktop?.url,
    };
    const renderImage = (matches) => (
        <img  className={classes.imageProp} src={backgrounds[device(matches)]} alt="large banner" loading="lazy" />
    );
    const renderSubHeadings = (text) => (
        text?.map((item) => (
            <div key={item.title} className={`${classes.nestedSubHeading} ${classes.sub_heading}`}>{item?.title}:
                <span>{item?.message}
                </span>
            </div>
        ))
    );
    return   (
        <div className={classes.largePromo}>
            <ResponsiveWrapper renderer={renderImage} />
            <div className={classes.promoBlock}>
                <div className={classes.singleSubHeadingBlock}>
                    <Typography className={classes.heading}>{replaceSpecialChar(promoData?.message?.heading, true)} </Typography>
                    <span className={classes.sub_heading}>{promoData?.message?.sub_heading}</span>
                </div>
                {promoData?.message?.promo_text?.map((item) => (
                    <div key={item?.heading} className={classes.subHeadingNestedBlock}>
                        <div className={classes.secondHeading}>{item?.heading}</div>
                        {item?.sub_heading.length === 1 && item.sub_heading[0].title === ''
                            ? <span className={classes.sub_heading}>{item.sub_heading[0].message}</span>
                            :                        renderSubHeadings(item?.sub_heading)}
                    </div>

                ))}
            </div>
        </div>
    );
};
PDPLargePromoBlock.propTypes = {
    promoData: object.isRequired,
    promoStyles: object.isRequired,
};

export default PDPLargePromoBlock;
